const keys = {
    JWT_CRYPT_KEY: '123',
    //'3AYFgvKJEMhP6GarJ3skCrSPWU6ExgZ52BgeUzDMuxQ4TVt4e947efdYmHJkf4e6W6ntsgAtntmjVJrb9gL5gypZ9wXp8mpfdSqb48hbNJPYkXRWcuNsNdqZfLcwefzxjUDAG2LXHr8LpqDgYCG27xZHfZsvJaLBXYmDfWLJ6CW9xYMAkJZ6Nn2rxxK5w5mJu2cbARUTrXNCMpMVWC8jGT2TXApp5eNfFTM8Tcqn7kznPCztRpJBKwvWFsUq26pJaSrFuzpzsWcrfW8X3rfrapREyYU7j2sgD6bHNrQwcTxrwePuXAYWvZRuUsNx7fs68an7vqZhCSdAptvevJeT4JgwN8j3WGjgr4nbQxfxnAVRA2sdru6ZT7LvnQV7B49JzTBBwuwckTKg5bgfnqnBHsLvHAqcvpDT3uabc7ZtkrfwC8XFVE6dbNaxypvWB267pbvBXKtc8hKeuDjFuYVtar3gFSxAsSzBsG3pq4RxLqJR3fysag297PvK3zUS2y9A',
    JWT_CRYPT_NAME: 'aaa',
}
module.exports = keys;
